import React from 'react';
import Icon from '../../../components/AppIcon';

const ReportCanvas = ({ components, onRemoveComponent, onReorderComponents, dataSources }) => {
  const handleMoveUp = (index) => {
    if (index > 0) {
      onReorderComponents?.(index, index - 1);
    }
  };

  const handleMoveDown = (index) => {
    if (index < components?.length - 1) {
      onReorderComponents?.(index, index + 1);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 min-h-[600px]">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-semibold text-foreground">Report Canvas</h2>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Layers" size={16} />
          <span>{components?.length} components</span>
        </div>
      </div>

      {components?.length === 0 ? (
        <div className="h-[500px] flex flex-col items-center justify-center border-2 border-dashed border-border rounded-lg">
          <Icon name="FileText" size={48} color="var(--color-muted-foreground)" className="mb-4" />
          <p className="text-lg font-medium text-muted-foreground mb-2">Start Building Your Report</p>
          <p className="text-sm text-muted-foreground">
            Add components from the library to create your custom report
          </p>
        </div>
      ) : (
        <div className="space-y-4">
          {components?.map((component, index) => (
            <div
              key={component?.instanceId}
              className="p-4 border border-border rounded-lg hover:border-primary/50 transition-all group"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name={component?.icon} size={20} color="var(--color-primary)" />
                </div>
                <div className="flex-1">
                  <h3 className="text-sm font-semibold text-foreground mb-1">{component?.name}</h3>
                  <p className="text-xs text-muted-foreground">{component?.description}</p>
                  {component?.config?.content && (
                    <div className="mt-2 p-2 bg-background rounded text-xs text-foreground">
                      {component?.config?.content}
                    </div>
                  )}
                </div>
                <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button
                    onClick={() => handleMoveUp(index)}
                    disabled={index === 0}
                    className="p-1 rounded hover:bg-muted disabled:opacity-50"
                  >
                    <Icon name="ChevronUp" size={16} />
                  </button>
                  <button
                    onClick={() => handleMoveDown(index)}
                    disabled={index === components?.length - 1}
                    className="p-1 rounded hover:bg-muted disabled:opacity-50"
                  >
                    <Icon name="ChevronDown" size={16} />
                  </button>
                  <button className="p-1 rounded hover:bg-muted">
                    <Icon name="Settings" size={16} />
                  </button>
                  <button
                    onClick={() => onRemoveComponent?.(component?.instanceId)}
                    className="p-1 rounded hover:bg-error/10 text-error"
                  >
                    <Icon name="Trash2" size={16} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {dataSources?.length > 0 && (
        <div className="mt-4 p-3 bg-background rounded-lg border border-border">
          <p className="text-xs font-medium text-foreground mb-2">Connected Data Sources:</p>
          <div className="flex flex-wrap gap-2">
            {dataSources?.map((source) => (
              <span
                key={source?.id}
                className="inline-flex items-center gap-1 px-2 py-1 bg-primary/10 text-primary rounded text-xs"
              >
                <Icon name={source?.icon} size={12} />
                {source?.name}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportCanvas;